import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";
const Portfolio = ({ classicHeader, darkTheme }) => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();

  const filters = {
    DESIGN: "Desing",
    BRAND: "Brand",
    PHOTOS: "Photos",
  };

  const projectsData = [
    {
      title: "CardinalTalent.ai",
      projectInfo:
        "CardinalTalent is AI-enabled Recruiting and HR software that comes with millions of built-in candidate leads. The AI automatically matches these candidate leads and candidate leads your team uploads to your open jobs.",
      // client: "Ruby Clinton",
      technologies: "(Ruby And Rails , ReactJs, Postgresql, Git, AWS)",
      industry: "Recruiting",
      // date: "July 16, 2019",
      url: {
        name: "https://cardinaltalent.ai/",
        link: "https://cardinaltalent.ai/",
      },
      thumbImage: "images/projects/cardinaltalent.png",
      sliderImages: [
        "images/projects/c2.png",
        "images/projects/c3.png",
        "images/projects/c5.png",
      ],
      categories: [filters.BRAND],
    },
    {
      title: "Datasort",
      projectInfo:
        "Use AI to do your resume parsing, and free your team to do the real work. Powered-by DataSort. World's number 1 Resume Parsing API.",
      client: "Ruby Clinton",
      technologies: " Python, Django, PostgreSQL",
      industry: "Resume Parser & API",
      date: "July 16, 2019",
      url: {
        name: "https://datasort.ai/",
        link: "https://datasort.ai/",
      },
      thumbImage: "images/projects/datasort.png",
      sliderImages: [
        "images/projects/datasort1.png",
        "images/projects/datasort2.png",
        "images/projects/datasort3.png",
      ],
      categories: [filters.DESIGN],
    },
    {
      title: "SOMA",
      projectInfo:
        "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
      client: "Ruby Clinton",
      technologies: "Python, Django, PostgreSQL",
      industry: "Art & Design",
      date: "July 16, 2019",
      url: {
        name: "https://cardinaltalentsolution.com/",
        link: "https://cardinaltalentsolution.com/",
      },
      thumbImage: "images/projects/soma.png",
      sliderImages: [
        "images/projects/soma1.png",
      ],
      categories: [filters.PHOTOS],
    },
    {
      title: "The Massage Rooms",
      projectInfo:
        "Online Massage booking portal that checks the availability of agents based on location and allows booking appointments and payment. It serves the health benefits of massage, it's connected to various physiotherapists that recommend the massage parlor.",
      client: "Ruby Clinton",
      technologies: "Laravel, MySQL, PHP",
      industry: "Art & Design",
      date: "July 16, 2019",
      url: {
        name: "https://www.themassagerooms.com/",
        link: "https://www.themassagerooms.com/",
      },
      thumbImage: "images/projects/massage.png",
      sliderImages: [
        "images/projects/massage1.png",
        "images/projects/massage2.png",
        "images/projects/massage3.png",
      ],
      categories: [filters.BRAND, filters.PHOTOS],
    },
    {
      title: "Siyasoft",
      projectInfo:
        "Developed a website to manage your accounts, finances, purchases,sales inventory manufacturing process and etc in an easy and efficient manner. It is comprehensive accounting software that covers your business's needs and saves you time and energy. With PWP you can easily manage all areas of your company sitting in any corner of the globe and concentrate on your business growth. It is developed in Core PHP. It is a cloud that holds the bills, inventory, accounts, Eway bills, and GST reports.",
      client: "Ruby Clinton",
      technologies: "MySQL, PHP, Google Cloud Platform, Git, Troubleshooting,LAMP, REST/RESTful APIs, MongoDB,Oracle,PostgreSQL",
      industry: "Art & Design",
      date: "July 16, 2019",
      url: {
        name: "https://pwp.siyasoft.com/",
        link: "https://pwp.siyasoft.com/",
      },
      thumbImage: "images/projects/siyasoft.png",
      sliderImages: [
        "images/projects/siyasoft1.png",
        "images/projects/siyasoft2.png",
        "images/projects/siyasoft3.png",
      ],
      categories: [filters.DESIGN],
    },
    {
      title: "Rekhamaniyar",
      projectInfo:
        "Created a one-stop webshop offering the widest variety of authentic and trendy ethnic fashion. Our online platform offers it all - sarees, salwar kameez, lehengas, and contemporary Indo Westerns with an exquisite collection of accessories.",
      client: "Ruby Clinton",
      technologies: "MySQL, Swift, PHP",
      industry: "Online Shopping",
      date: "July 16, 2019",
      url: {
        name: "https://www.rekhamaniyar.in/",
        link: "https://www.rekhamaniyar.in/",
      },
      thumbImage: "images/projects/rekha.png",
      sliderImages: [
        "images/projects/rekha1.png",
        "images/projects/rekha2.png",
        "images/projects/rekha3.png",
        "images/projects/rekha4.png",
      ],
      categories: [filters.BRAND],
    },
    {
      title: "PingPronto",
      projectInfo:
        "End to End recruitment & Software solutions for Tech & Non-Tech.",
      client: "",
      technologies: "Laravel, PHP, Mysql, Git, AWS, ChatGTP, Stripe",
      industry: "Outsourcing and Offshoring Consulting",
      date: "Aug 01, 2023",
      url: {
        name: "https://pingpronto.com/",
        link: "https://pingpronto.com/",
      },
      thumbImage: "images/projects/pingpronto.png",
      sliderImages: [
        "images/projects/pingpronto.png",
        "images/projects/pingpronto.png",
        "images/projects/pingpronto.png",
        "images/projects/pingpronto.png",
      ],
      categories: [filters.DESIGN, filters.PHOTOS],
    },
  ];

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
    });

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: `*` })
        : isotope.current.arrange({ filter: `.${filterKey}` });
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  return (
    <>
      <section
        id="portfolio"
        className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
      >
        <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
          {/* Heading */}
          <div className="position-relative d-flex text-center mb-5">
            <h2
              className={
                "text-24  text-uppercase fw-600 w-100 mb-0 " +
                (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
              }
            >
              Portfolio
            </h2>
            <p
              className={
                "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
                (darkTheme ? "text-white" : "text-dark")
              }
            >
              {" "}
              My Work
              <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
            </p>
          </div>
          {/* Heading end*/}
          {/* Filter Menu */}
          <ul
            className={
              "portfolio-menu nav nav-tabs justify-content-center border-bottom-0 mb-5 " +
              (darkTheme ? "nav-light" : "")
            }
          >
            <li className="nav-item">
              <button
                className={"nav-link " + (filterKey === "*" ? "active" : "")}
                onClick={handleFilterKeyChange("*")}
              >
                All
              </button>
            </li>
            {/* {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={
                    "nav-link " +
                    (filterKey === filters[oneKey] ? "active" : "")
                  }
                  onClick={handleFilterKeyChange(filters[oneKey])}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))} */}
          </ul>
          {/* Filter Menu end */}
          <div className="portfolio popup-ajax-gallery">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item " +
                      project.categories.join(" ")
                    }
                    key={index}
                  >
                    <div className="portfolio-box rounded">
                      <div className="portfolio-img rounded">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />
                        <div className="portfolio-overlay">
                          <a
                            className="popup-ajax stretched-link"
                            href=""
                            onClick={() => {
                              setSelectedProjectDetails(projectsData[index]);
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                          />
                          <div className="portfolio-overlay-details">
                            <h5 className="text-white fw-400">
                              {project.title}
                            </h5>
                            <span className="text-light">Category</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      <div className="project-details-modal">
        {/* Modal */}
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          darkTheme={darkTheme}
        ></ProjectDetailsModal>
      </div>
    </>
  );
};

export default Portfolio;
